<template>
    <div class="itemview_wrapper">        
        <div class="page_title"> <font-awesome-icon icon="parking" /> P샵 상품</div>
        <div class="loading-spinner" v-if="is_loading">
            <base-spinner></base-spinner>
        </div>
        <div class="itemview_body" v-if="!is_loading">
            <div class="item_img">
                <div v-if="goods.image" class="img_area">
                    <img :src="`/storage/${goods.image}`">
                </div>
                <div v-else class="blank_img">
                    {{goods.title}}
                </div>
            </div>

            <div class="item_info">
                
                <h1>{{goods.title}}</h1>
                <div v-if="goods.price>0" class="price">{{addCom(goods.price)}}<span class="unit">원</span></div>
                <div v-else class="price">{{addCom(Math.abs(goods.point))}} P</div>
                <!--지급 포인트 -->
                <div v-if="goods.category ==='point'" class="givepoint">
                    <div>지급 포인트</div>
                    <div class="point">{{addCom(goods.point)}}<img src="@/assets/imgs/icon_point.png"> </div>
                </div>

                <!--제한 사항 -->
                <div class="limit">

                </div>

                <!--포인트 상품 강조 -->
                <div class="pointaccent">
                    해당 상품은 조기 매진 될 수 있습니다.
                </div>

                <!-- 부연 설명 -->
                <p>{{goods.description}}</p>
                <div class="addCount">
                    <div class="addsub">
                        <button type="button" class="_sub" @click="decrease">
                            <span class="blind">수량 빼기</span>
                        </button>
                        <input type="text" class="_counter"  v-model.trim="counter" @keypress="ckCounter($event)">
                        <button type="button" class="_add" @click="increase">
                            <span class="blind">수량 추가</span>
                        </button>
                    </div>
                </div>
              
                <div class="total_price">
                    <div class="title">총 상품 포인트</div>
                    <div class="sum">총 수량 <span >{{counter}}</span>개 | <span class="total">{{addCom(getTotalPoint)}}<span class="unit">P</span> </span> </div>
                </div>               
                

                <!-- 본인인증 안한 유저는 본인인증 페이지로 -->
                <template v-if="name.val === ''">
                    <div class="ck_auth">     
                        <span>상품 구매를 위해 <strong>본인인증</strong>이 필요합니다.</span>   
                        <base-button mode="skyblue" @click="linkTo('selfAuth')">본인인증 하러 가기</base-button>               
                        <!-- <router-link :to="{name:'selfAuth'}">본인인증 하러 가기</router-link>    -->
                    </div>
                </template>
                
                <template v-if="goods.category==='general' && name.val !==''">
                    <div class="infoBlock">
                        <div class="label">
                            이름                           
                        </div>
                        <div class="inputBox">
                            <span class="user_name">{{name.val}}</span>
                        </div>                                              
                    </div>
                    <div class="infoBlock">
                        <div class="label">
                            *주소                           
                        </div>
                        <div class="inputBox">
                            <input type="text" v-model.trim="roadAddress.val" > 
                        </div>                                              
                    </div>
                     <div class="infoBlock">
                        <div class="label">
                            *휴대폰                           
                        </div>
                        <div class="inputBox mobile">
                            <input type="text" v-model.trim="phone1.val" readonly>-
                            <input type="text" v-model.trim="phone2.val" >-
                            <input type="text" v-model.trim="phone3.val" > 
                        </div>                                              
                    </div>
                    <div class="infoBlock">
                        <div class="label">
                            이메일                           
                        </div>
                        <div class="inputBox">
                            <input type="text" v-model.trim="email.val" @blur="clearValidity('email')"> 
                        </div>                                              
                    </div>
                   
                </template>  
                
                <template v-if="name.val !== ''"> 
                    <div class="ck_caution">
                        <base-checkbox :checkvalue="1"  @click="icheck"/>
                        <span>P샵 구매확인 확인</span> 
                    </div>
                    
                    <div v-if="!formIsValid" class="alert-valid">
                        <div><span class="ic_alert animate-bounce"></span></div>
                        <div class="text">{{isValidMent}}</div>
                    </div>                  
                    
                    <div v-if="!itemSelect.isValid" class="alert-valid">
                        <div><span class="ic_alert animate-bounce"></span></div>
                        <div class="text">[아래 구매 확인 사항]을 확인후 체크해 주세요!!!</div>
                    </div>
                    
                    <div class="btn_part">
                        <base-button mode="orange" @click="buyGoods">구매하기</base-button>
                    </div>
                </template>                 
            </div>
        </div>      

       

        <div class="add_info">
            <h1><font-awesome-icon icon="parking" /> P샵 구매 확인 사항</h1>
            <div v-if="goods.category==='general'">
                <p>
                    해당 상품은 <strong>조기 매진</strong> 될 수 있습니다.<br>
                    
                    <span class="deposit_bank_info">목요일까지 구매된 상품을 금요일 일괄 배송하기 때문에 월~목요일까지 취소 가능 합니다.</span>
                </p>
                <p class="accent">
                주문 취소는 마이페이지 P샵 상품 구매내역에서 하실수 있습니다.
                </p>  
            </div>
            <div class="ckeditor_view">
                <ckeditor :editor="editor" :disabled="editorDisabled" :model-value="editorData"></ckeditor>
            </div> 
        </div>
       
    </div>
    <base-dialog :show="completebuy" title="구매완료"   fixed>
        <div class="dialog_box">
            <div class="item_title">
              <h1>[ {{goods.title}} ] 구매완료</h1>  
              <span>구매내역은 마이페이지에서 확인할 수 있습니다.</span>           
            </div>
            <div class="input_area">   
                <div class="description danger">
                    금요일 일괄 배송으로 취소는 <br>
                    <strong>월요일 ~ 목요일</strong><br>
                    까지만 가능 합니다.        
                </div>               
            </div>
            <div class="btn_part">
                <div class="btn_block">
                    <base-button mode="darkblue" @click="popClose()">확인</base-button>    
                </div>
                
            </div>
        </div>
    </base-dialog>
</template>
<script>
import { addCommas } from '@/utils/checkdata.js';
import { banklists } from '@/components/mixins/banklists.js';
import { auth } from '@/components/mixins/auth.js';
import { icheck } from '@/components/mixins/icheck.js';
import { authInfo } from '@/components/mixins/authInfo.js';

import DecoupledEditor from '@ckeditor/ckeditor5-build-decoupled-document';
import io from "socket.io-client";
export default {
    name:'goodsview',
    mixins:[ auth,banklists,icheck,authInfo],
    props:['id'],
    data(){
        return{
            counter:1,
            totalPrice:0,
            totalPoint:0,
            user_name:null,
            bank_name:null,
            bank_num:null,
            formIsValid:true,
            is_loading:true,
            confirm_caution:false,
            isValidMent:'구매자 정보를 확인해 주세요!',
            completebuy:false,    
            editorData: '<p>상세정보를 불러옵니다.</p>',    
            editor:DecoupledEditor,      
            editorDisabled: true,   
            socket: io(this.$store.state.serverDomain + ":3000"),  
        }
    },
    computed:{
        goods:{
            get(){
                return this.$store.state.goods.goodsview;
            }
        },
        getTotalPrice(){
            return this.$store.state.goods.goodsview.price * this.counter;
        },
        getTotalPoint(){
            return Math.abs(this.$store.state.goods.goodsview.point * this.counter);
        },
        
    },
    mounted(){
        this.goodsView();
        this.authInfo();
    },
    methods: {
        updateViewer() {
            this.editorData =  this.goods.content;
        },
        linkTo(routeName, param){
            this.$router.push( {name:routeName, params:param} )   
        },        
        clearValidity(input) {
            if(this[input].val !=='')
            {
                if(!this[input].wordValid){
                    this[input].val = "";
                    this[input].wordValid = true;
                }else{
                    this[input].isValid = true;
                }          

            }
        },
        validateForm() {
            this.formIsValid = true;
            //이름 체크
            if (this.name.val === '' || this.name.val.length < 2 || !this.name.wordValid)
            {
                this.name.isValid = false;
                this.formIsValid = false;
            }

            //주소
            if (this.addressDetail.val === '')
            {
                this.addressDetail.isValid = false;
                this.formIsValid = false;
            }

            //휴대폰
            if (this.phone2.val === '' || !this.phone2.wordValid )
            {
                this.phone2.isValid = false;
                this.formIsValid = false;
            }
            if (this.phone3.val === '' || !this.phone3.wordValid )
            {
                this.phone3.isValid = false;
                this.formIsValid = false;
            }           
           
            //이메일은 필수가 아니지만 있으면 이메일 형식 체크
            if (this.email.val !== '' &&  !this.email.val.includes("@"))
            {
                this.email.isValid = false;
                this.formIsValid = false;
                this.isValidMent = '이메일 형식이 맞지 않습니다.';
            }  
            
            // if (this.agreepolicy.val.length === 0)
            // {
            //     this.agreepolicy.isValid = false;
            // }
        },  
        async buyGoods(){          
            
            if(this.authCheck() !==true)
            {
                return
            }
            
            this.validateForm();
            if (!this.formIsValid ) {
                return;
            }

            if(this.itemSelect.val[0] !=="1")
            {
                //alert('유의사항 확인을 체크 해주세요');
                this.itemSelect.isValid = false;
                return;
            }
            
            //구매가능 체크             
            if(this.getTotalPoint > this.user.point)
            {
                this.formIsValid =false;
                this.isValidMent = '포인트가 부족합니다.';
                return;
            }
            const formData = {
                goodsId:this.goods.id,
                user_id:this.user.id,               
                count:this.counter,
                name:this.name.val,
                zonecode:this.zonecode.val,
                roadAddress:this.roadAddress.val,
                addressDetail:this.addressDetail.val,
                phone1:this.phone1.val,
                phone2:this.phone2.val,
                phone3:this.phone3.val,
                email: this.email.val,   
            }            
            
            try {
                const response = await this.$store.dispatch("goods/goodsBuy", formData)
                console.log(response); 
                if(response.goodsBuy)
                {
                    this.$store.commit('updateUserPoint',response.user);    
                }
                this.completebuy =true;
                this.socket.emit("newGoodsState");
                this.$flashMessage.show({
                    type: response.itemBuy===false?"error":"info",
                    title: response.message,
                    message: response.message,
                });   
                           
            }catch(error){
                console.log(error);
               
            }

        },
        ckCounter(evt){
            evt = (evt) ? evt : window.event;
            var charCode = (evt.which) ? evt.which : evt.keyCode;
            if ((charCode > 31 && (charCode < 48 || charCode > 57)) && charCode !== 46) {
                evt.preventDefault();
            } else {
                return true;
            }
        },
        increase(){
            this.counter++;
        },
        decrease(){
            if(this.counter === 1)
            {
                alert('최소단위는 1개입니다.');
                return;
            }
            this.counter--;        

        },
        addCom(val)
        {
            return addCommas(val);
        },
        async goodsView() {            
            const formData = {
                goodsId:this.id
            }
            try {
                const response = await this.$store.dispatch("goods/goodsView", formData)
                //console.log(response);
                this.goods = response.data;
                this.updateViewer();
                this.is_loading = false;
                //console.log("안나오는듯",this.postlists.data.length);
            }catch(error){
                console.log(error.response);
            }
            this.isLoading = false;
        },
        agree($event){
            
            if($event.target.id === 'confirm_caution' || $event.target.id === "icheck")
            {
                document.querySelector('#confirm_caution').classList.toggle('agree');
            }
        }, 
        popClose(){
            this.completebuy = false;
        }       
    }

}
</script>
<style lang="scss" scoped>
@import '@/assets/scss/item_view';
@import "@/assets/scss/ani_infinite";
.ck_caution{
    display: flex;
    justify-content: flex-start;
    margin-top:10px;
}
.ck_auth{
    margin: 20px 0 30px 0;
    display: flex;
    flex-direction: column;
    justify-content: center;
    span{
        display: block;
        padding-bottom:10px;
        text-align: center;
    }
    a{
        background:aqua;
        padding:10px;
        border-radius: 5px;
        text-decoration: none;
    }    
}
 .infoBlock{
               
    margin-top:10px;
    display:flex;
    justify-content: space-between;
    .label{
        width: 20%;
        color:rgb(95, 95, 95)
    }
    .inputBox{
        width: 80%;
        .user_name{
            display: block;
            padding-bottom: 10px;
            border-bottom: 1px solid #dadada;
            font-weight: bold;
        }
        input{
            width: 100%;
        }
    }
    .mobile{
        display: flex;
        justify-content: space-between;
        line-height: 30px;
        input{width:30%;text-align: center;}
    }
    input,select{
        padding:0 20px;
        border: 1px solid #dadada;
        font-size: 12px;                    
        line-height:30px;                     
    }
    // input:first-child{width:20%;}
    // input:nth-child(2){width:30%;}
    // input:nth-child(3){width:50%;}
}
.alert-valid{
    margin-top:20px;
}
.ic_alert{    
    background: url(../../assets/imgs/sp_account.png) no-repeat -60px 0; 
}
</style>
